export const Post18707 = () => {
    return (
        <div class="w-full text-left">
            <div className="w-full min-h-[400px] md:min-h-[500px] rounded-xl" style={{background: `url(/blog-photos/insu.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            </div>
       
            <p className="mt-4">
                <strong>The reign of Artificial Intelligence is on an upward swing, and it’s time for industries across the board to adapt to the changing landscape.&nbsp; Join ECC for an unforgettable keynote presentation by John Standish, Co-Founder and Chief Analytics Officer for Infinilytics, Inc.</strong>
            </p>
            <ul className="list-disc list-inside mt-4">
                <li>Demystify Artificial Intelligence for the business of insurance</li>
                <li>Identify and explore the need for leadership within the 4th Industrial Revolution</li>
                <li>Predict how Artificial Intelligence is changing business as we know it</li>
                <li>Adapt to A.I. to strengthen your professional skills</li>
                <li>Get engaged to lead change in your job and community</li>
            </ul>
            <div className="mt-4 text-center">
                <a className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" target="_blank" rel="noopener noreferrer" href="http://it-mis.com/easternclaims">
                    Eastern Claims Conference
                </a>
            </div>
            <a className="mt-8" href="http://it-mis.com/easternclaims/" >
                <img decoding="async" src="/blog-photos/ecc.jpg" data-src="/blog/photos/ecc.jpg" alt="" width="173" height="86" />
            </a>
            <p className="mt-4">
                <img decoding="async" class="aligncenter size-full wp-image-17668 lazyloaded" src="/blog-photos/john1.png" data-src="/blog-photos/john1.png" alt="" width="303" height="305" />          
            </p>
            <p className="mt-4">
                <strong>John Standish, Co-Founder and CAO Infinilytics, Inc.</strong>
            </p>
            <p>&nbsp;</p>
            <p className="mt-4">
                In addition to his position at Infinilytics, John is a consultant in the insurance industry for first party bad faith litigation involving fraud investigations, state mandated compliance, and civil rico actions.&nbsp; He has testified as an expert for fraud, investigations, and accident reconstruction in legal proceedings
            </p>
            <img decoding="async" className="m-auto" src="/blog-photos/Infinilytics-logo.jpg" width="248" height="87" />                
        </div>
    )
}